import { useLocation } from 'react-router-dom'

import { NEW_CHARTS_ENABLED } from '../config/featureToggles'

const QUERY_PARAM = 'new-charts'

export default function useFeatureNewCharts(): boolean {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const hasNewChartEnabledInUrl = params.get(QUERY_PARAM) === 'true'

  return NEW_CHARTS_ENABLED || hasNewChartEnabledInUrl
}
